<template>
  <div class="jump-box">
    <div class="jump">
      <img src="@/assets/images/loading.gif" alt=""/>
      <p style="font-size: 0.3rem">
        正在跳转到支付页面，请稍候~
      </p>
    </div>
  </div>
</template>

<script>
import {cashierPayOrder} from '@/api/api';
import config from "@/config";

// 分发器页面，  用户扫码后进入的第一个页面：
// 判断是否存在channelUserId, 如果存在则直接跳到 对应的支付页面，如果不存在则重定向到对应的页面。
export default {
  components: {},

  mounted() {

    // eslint-disable-next-line no-constant-condition
    // if (true) {
    //   this.$router.push({name: "CashierWxpay"})
    //   return;
    // }

    //TODO 需要获取到不同的商户的userId
    // if(channelUserId.getChannelUserId()){// 存在
    //   //重定向到对应的支付页面
    //   this.$router.push({name: wayCodeUtils.getPayWay().routeName})
    //   return ;
    // }

    const that = this;
    // 以下为不存在
    cashierPayOrder().then(res => {
      location.href = res;
			// location.href = "https://mp.weixin.qq.com/a/~luHkDcFSPAMXCkhNj6lmyw~~";
    }).catch(res => {
      that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
    });
  }
}
</script>
<style lang="css" scoped>
.jump-box {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
